import React, { Component } from 'react'
import { items } from './data'
import OdInput from './OdInput'
import SubTreeItem from './SubTreeItem'
import styles from './s.module.css'

export default class SubTree extends Component {
  constructor (props) {
    super(props)
    this.state = {
      od: '0'
    }
    this.handleOdChange = this.handleOdChange.bind(this)
  }

  handleOdChange (e) {
    this.setState({
      od: e.target.value
    })
  }

  render () {
    let tree = []
    const content = items[this.props.content]
    for (let i = 0; i < content.length; i++) {
      tree.push(<SubTreeItem key={`mti${i}`} mainIndex={this.props.parent} index={content[i]}
        od={this.state.od} />)
    }
    return (
      <div>
        <OdInput value={this.state.od} onChange={this.handleOdChange} useSelector={this.props.useSelector} />
        <ul className={styles.subTree}>{tree}</ul>
      </div>
    )
  }
}

// SubTree.propTypes = {
//   content: PropTypes.string,
//   parent: PropTypes.number,
//   useSelector: PropTypes.bool
// }
